module.exports = __webpack_public_path__ + "static/img/A (18).b724c6ad.png";